import { useEffect, useState } from "react";
import { TextField, Autocomplete, MenuItem } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// custom imports
import showToast from "../../../Utils/Toast/ToastNotification";
import { HandleApiError } from "../../../Utils/CommonErrors/HandleApiError";
import { hideLoader, showLoader } from "../../../Redux/Slice/Loader/loaderSlice";
import userManagementService from "../../../Services/UserManagement/UserManagementService";
import projectManagementService from "../../../Services/projectManagementService/projectManagementService";
import TemplateService from "../../../Services/TemplateService/TemplateService";
import inspectionService from "../../../Services/inspectionService/inspectionService";
// css
import "./UpdateInspection.css";

const UpdateInspection = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [users, setUsers] = useState([]);
  const [projects, setProjects] = useState([]);
  const [template, setTemplate] = useState([]);
  const last_updated_by = useSelector(
    (state) => state.auth?.user?.data?.body?.data?.userData?.id
  );

  const token = useSelector((state) => state.auth?.user?.data?.body?.data?.token)

  // validation
  const inspectionSchema = Yup.object({
    inspection_name: Yup.string().required("Inspection Name is required"),
    template_id: Yup.string().required("Template name is Required"),
    project_id: Yup.string().required("Project is Required"),
    inspection_date: Yup.string().required("Date is required"),
    inspector_ids: Yup.array()
      .min(1, "At least one inspector is required")
      .required("Inspector is required"),
  });
  const [initialValues, setInitialValues] = useState({
    inspection_name: "",
    inspection_date: "",
    template_id: "",
    project_id: "",
    inspector_ids: [],
    status: "",
    last_updated_by: last_updated_by,
  });

  // get all userss
  const getAllUser = async () => {
    try {
      const response = await userManagementService.getAllUserList(token);
      if (response?.data?.statusCode === 200) {
        setUsers(response.data?.body?.data?.users);
      } else {
        showToast("error", response.data.body.message);
      }
    } catch (error) {
      await HandleApiError(error);
    }
  };

  // get all projects
  const getAllProject = async () => {
    try {
      const response = await projectManagementService.getAllProjectList(token);
      if (response?.data?.statusCode === 200) {
        setProjects(response.data?.body?.data?.projects);
      } else {
        showToast("error", response.data.body.message);
      }
    } catch (error) {
      await HandleApiError(error);
    }
  };

  // get all the templates
  const getAllTemplates = async () => {
    try {
      const response = await TemplateService.getAllTemplate(token);
      if (response?.data?.statusCode === 200) {
        setTemplate(response.data?.body?.data?.projects);
      } else {
        showToast("error", response.data.body.message);
      }
    } catch (error) {
      await HandleApiError(error);
    }
  };

  useEffect(() => {
    const fetchInspectionData = async () => {
      if (users.length === 0) return;

      try {
        const response = await inspectionService.getInspection(id, token);
        if (response?.data?.statusCode === 200) {
          const inspectionData = response.data?.body?.data?.inspection[0];
          const selectedInspectors = users.filter((user) =>
            inspectionData.inspectors?.some((i) => i.id === user.id)
          );

          const matchedProject = projects.find(
            (project) => project.id === inspectionData.project_id
          );

          setInitialValues({
            inspection_name: inspectionData.inspection_name || "",
            inspection_date: inspectionData.inspection_date || "",
            template_id: inspectionData.template_id || "",
            inspector_ids: selectedInspectors || [],
            status: inspectionData.status,
            project_id: inspectionData.project_id,
            last_updated_by,
          });
        } else {
          showToast("error", response.data.body.message);
        }
      } catch (error) {
        await HandleApiError(error);
      }
    };

    fetchInspectionData();
  }, [users, id]);

  useEffect(() => {
    const fetchData = async () => {
      await getAllUser();
      await getAllProject();
      await getAllTemplates();
    };
    fetchData();
  }, []);


  // on submit function 
  const onSubmit = async (values) => {
    const payload = {
      ...values,
      inspector_ids: values.inspector_ids.map((user) => user.id),
    };

    dispatch(showLoader());
    try {
      const response = await inspectionService.updateInspection(id, payload, token);

      if (response?.data?.statusCode === 200) {
        showToast("success", response.data.body.message);
        navigate(-1);
      }
    } catch (error) {
      await HandleApiError(error);
    } finally {
      dispatch(hideLoader());
    }
  };

  return (
    <div className="main-inner-block">
      <div className="heading-content">Edit Inspection</div>
      <div className="content">
        <div className="white-box">
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={inspectionSchema}
            onSubmit={onSubmit}
          >
            {({
              values,
              handleChange,
              setFieldValue,
              handleBlur,
              errors,
              touched,
            }) => (
              <Form onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}>
                <div class="create-user-block">
                  <div className="profile-box-area inspection-blk d-flex flex-wrap align-items-center">
                    <div className="profile-box inspectiondetails">
                      <label
                        htmlFor="inspection-name"
                        className="form-label m-0"
                      >
                        Inspection Name
                      </label>

                      <input
                        type="text"
                        id="inspection-name"
                        name="inspection_name"
                        className="form-control"
                        placeholder="Enter template name"
                        value={values.inspection_name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {errors.inspection_name && touched.inspection_name && (
                        <div className="error">{errors.inspection_name}</div>
                      )}
                    </div>

                    <div className="profile-box inspectiondetails">
                      <label
                        htmlFor="inspection-date"
                        className="form-label m-0"
                      >
                        Inspection Date
                      </label>
                      <input
                        type="date"
                        id="inspection-date"
                        className="form-control"
                        name="inspection_date"
                        value={
                          values.inspection_date
                            ? values.inspection_date.split("T")[0]
                            : ""
                        }
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {errors.inspection_date && touched.inspection_date && (
                        <div className="error">{errors.inspection_date}</div>
                      )}
                    </div>

                    <div className="profile-box inspectiondetails">
                      <label htmlFor="project_id" className="form-label m-1">
                        Project Address <span>*</span>
                      </label>
                      <Autocomplete
                        disablePortal
                        id="project_id"
                        options={projects.map((t) => ({
                          label: t.address,
                          value: t.id,
                        }))}
                        getOptionLabel={(option) => option.label}
                        isOptionEqualToValue={(option, value) =>
                          option.value === value.address
                        }
                        value={
                          projects.find((t) => t.id === values.project_id)
                            ? {
                              label: projects.find(
                                (t) => t.id === values.project_id
                              ).address,
                              value: values.project_id,
                            }
                            : null
                        }
                        onChange={(e, selectedOption) =>
                          setFieldValue(
                            "project_id",
                            selectedOption ? selectedOption.value : ""
                          )
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Select Project"
                            variant="outlined"
                            className="custom-input-box"
                          />
                        )}
                      />
                      {errors.project_id && touched.project_id && (
                        <div className="error">{errors.project_id}</div>
                      )}
                    </div>

                    <div className="profile-box inspectiondetails">
                      <label htmlFor="template_id" className="form-label m-1">
                        Inspection Template <span>*</span>
                      </label>

                      {values.status === "Complete" ? (
                        <input
                          type="text"
                          id="template-name"
                          name="template_name"
                          className="form-control"
                          placeholder="Template Name"
                          value={
                            template.find((t) => t.id === values.template_id)?.template_name || ""
                          }
                          readOnly
                        />
                      ) : (
                        <Autocomplete
                          disablePortal
                          id="template_id"
                          options={template.map((t) => ({
                            label: t.template_name,
                            value: t.id,
                          }))}
                          getOptionLabel={(option) => option.label}
                          isOptionEqualToValue={(option, value) =>
                            option.value === value.value
                          }
                          value={
                            template.find((t) => t.id === values.template_id)
                              ? {
                                label: template.find((t) => t.id === values.template_id)
                                  ?.template_name,
                                value: values.template_id,
                              }
                              : null
                          }
                          onChange={(e, selectedOption) =>
                            setFieldValue(
                              "template_id",
                              selectedOption ? selectedOption.value : ""
                            )
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Select Template"
                              variant="outlined"
                              className="custom-input-box"
                            />
                          )}
                        />
                      )}

                      {errors.template_id && touched.template_id && (
                        <div className="error">{errors.template_id}</div>
                      )}
                    </div>


                    <div class="profile-box inspectiondetails">
                      <label htmlFor="inspector" className="form-label m-0">
                        Inspector
                      </label>
                      <Autocomplete
                        className="autocomplete-box position-relative"
                        sx={{
                          m: 1,
                          // width: 375,
                          "& .MuiOutlinedInput-root": {
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderBottom: "1px solid #e6e6e6 !important", // Remove the default border
                            },
                            "&:before, &:after": {
                              borderBottom: "1px solid #e6e6e6 !important", // Ensure it applies
                            },
                            "&.Mui-focused:after": {
                              borderBottom: "1px solid #e6e6e6 !important", // Override focus blue border
                            },
                          },
                        }}
                        multiple
                        options={users}
                        getOptionLabel={(option) => `${option.name}`}
                        disableCloseOnSelect
                        value={values.inspector_ids}
                        onChange={(event, newValue) => {
                          setFieldValue("inspector_ids", newValue);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            // placeholder="Inspector"
                            className="custom-input-box"
                          />
                        )}
                        renderOption={(props, option, { selected }) => (
                          <MenuItem
                            {...props}
                            key={option.id}
                            value={option.id}
                            sx={{ justifyContent: "space-between" }}
                          >
                            {`${option.name}`}
                            {selected ? <CheckIcon color="info" /> : null}
                          </MenuItem>
                        )}
                      />
                      {errors.inspector_ids && touched.inspector_ids && (
                        <div className="error">{errors.inspector_ids}</div>
                      )}
                    </div>

                    <div class="profile-box inspectiondetails">
                      <label htmlFor="status" className="form-label m-0">
                        Status
                      </label>
                      <select
                        class="form-select"
                        id="status"
                        name="status"
                        value={values.status}
                        onChange={handleChange}
                      >
                        <option selected value="Scheduled">
                          Scheduled{" "}
                        </option>
                        <option value="Not Started">Not Started</option>
                        <option value="In Progress">In Progress</option>
                        <option value="Complete">Complete</option>
                        <option value="Archive">Archive</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="text-center update-div text-center update-div d-flex align-items-center justify-content-center gap-2 mt-5">
                  <button
                    type="button"
                    class="green-btn submit-btn"
                    onClick={() => navigate(-1)}
                  >
                    Back
                  </button>

                  <button
                    type="submit"
                    class="green-btn submit-btn"
                  // style={{ marginLeft: "10px" }}
                  >
                    Update
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default UpdateInspection;
